import React, { useState, useEffect, useContext, useRef } from "react";
import camaraIcon from "../images/slider/camera.svg";
import mapIcon from "../images/location.svg";
import { PostApi } from "../api/api-service";
import { API_Path, imgBaseUrl, numRegex, wpNumber } from "../Const";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import NoPropertyImg from "../images/no_property.png";
import DropdownComponent from "../components/dropdown/DropdownComponent";
import DropdownPropertys from "../components/dropdown/DropdownPropertys";
import DropdownMulti from "../components/dropdown/DropdownMulti";
import ImagesModal from "../components/modal/ImagesModal";
import CommonPagination from "../components/CommonPagination";
import { Link, useLocation, useNavigate } from "react-router";
import { formatShortNumber, getQuarter, quarterARY, rentFqcyARY, sendWhatsAppMessage } from "../components/CommonFun";
import { AuthContext } from "../context/AuthContext";
import { fatchcompletionTypeFind } from "../components/CommonApi";
import DropdownPayment from "../components/dropdown/DropdownPayment";
import noDataFound from "../images/noDataFound.png";
import { StoreContext } from "../context/StoreContext";
import useTooltipPosition from "../components/CustomizedHook/updatePosition";
import ProjectLoader from "../components/loader/ProjectLoader";
import AutoMultiSearch from "../components/CustomizedHook/AutoMultiSearch";
import DropdownQuarter from "../components/dropdown/DropdownQuarter";
import AautocompleteSearch from "../components/CustomizedHook/AautocompleteSearch";
import MoreFilters from "../components/dropdown/MoreFilters";
import moment from "moment";
import { RECamera, RELocation, REWhatsapp } from "../components/icons/IconSvg";

export default function NewProject() {
    const navigate = useNavigate();
    const { completionType, fetchCompletionType, purposeType, fetchPurposeType, categoriesType, fetchCategoriesType, cityData, fatchCity, devNames, fetchDevNames } = useContext(AuthContext);
    const { localityData, fatchLocality } = useContext(StoreContext);
    const { wrapperRef, tooltipRef, position, updatePosition } = useTooltipPosition();
    const location = useLocation();
    const [isLoader, setIsLoader] = useState(true);
    const [btnLoader, setBtnLoader] = useState({ serach: false, reset: false });
    const [projectImgsmdl, setProjectImgsmdl] = useState([]);
    const [imgModalShow, setImgModalShow] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(28);
    const [totalPages, setTotalPages] = useState(1);
    const [projectData, setProjectData] = useState([]);
    const [combinedData, setCombinedData] = useState([]);
    const [imgID, setImgID] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [filterData, setFilterData] = useState({
        purpose: "Sale",
        categoryName: [],
        categories: [],
        categorySlug: "Residential",
        baths: [],
        bedRooms: [],
        minArea: "",
        maxArea: "",
        minPrice: "",
        maxPrice: "",
        locality: "",
        city: "",
        completion: "all",
        rent_frequency: "",
        completionPercentage: "",
        completionDate: "",
        paymentPlan: "",
        country: "",
        state: "",
        searchValue: "",
        developers: [],
    });
    const [imgFlag, setImgFlag] = useState(false);

    const hasFetched = useRef(false);

    useEffect(() => {
        if (hasFetched.current) return;
        const locationdata = location?.pathname?.split("/");
        const params = new URLSearchParams(locationdata[2]);
        const parsedFilters = {
            purpose: params.get("purpose")?.split(",") || "Sale",
            categories: params.get("categories")?.split("%2") || [],
            bedRooms: params.get("bed")?.split(",") || [],
            baths: params.get("bath")?.split(",") || [],
            minPrice: parseInt(params.get("price_min"), 10) || 0,
            maxPrice: parseInt(params.get("price_max"), 10) || 0,
            minArea: parseInt(params.get("area_min"), 10) || 0,
            maxArea: parseInt(params.get("area_max"), 10) || 0,
            completion: params.get("completion") || "all",
            locality: params.get("locality") || "",
            rent_frequency: params.get("rent_frequency") || "",
            city: params.get("city") || "",
            completionPercentage: params.get("pre_handover_payment_max") || "",
            paymentPlan: params.get("pre_handover_payment_max") || "",
            completionDate: params.get("handover_date") || "",
            developers: params.get("dev")?.split(",") || [],
            categorySlug: "Residential",
            categoryName: [],
            country: "",
            state: "",
            searchValue: "",
        };
        setFilterData(parsedFilters);
        const isData = Object.values(parsedFilters).every((value) => value?.length === 0 || value === "" || value === 0);
        if (!isData) {
            hasFetched.current = true;
            fechLtsProjects(1, parsedFilters);
        }
    }, [location.pathname]);

    useEffect(() => {
        fetchCategoriesType();
        fetchPurposeType();
        fatchLocality();
        fatchCity();
        fetchDevNames();
        fetchCompletionType();
    }, []);

    const filterCallBack = (option, name) => {
        let newFilterData = filterData;
        newFilterData[name] = option;
        if (name === "minPrice" || name === "maxPrice" || name === "minArea" || name === "maxArea") {
            if (option != 0) {
                if (/^0/.test(option)) option = option.replace(/^0+/, "");
                if (numRegex.test(option)) setFilterData({ ...filterData, [name]: option });
            } else setFilterData({ ...filterData, [name]: "" });
        } else if (name === "completion") setFilterData({ ...filterData, [name]: option });
        else setFilterData(option);
        // if (option == "all") filterReset();
    };
    const fechLtsProjects = async (page = 1, item) => {
        let fromData;
        let endDate;
        if (item?.completionDate) {
            const splitCDate = item?.completionDate?.split("&");
            fromData = moment(splitCDate?.[0]).format("DD-MMM-YYYY");
            endDate = moment(splitCDate?.[1]).format("DD-MMM-YYYY");
        }
        let data = {
            // categoryName: item?.categorySlug ? [item?.categorySlug] : null,
            category: item?.categories?.length > 0 ? item?.categories : null,
            bedRooms:
                item?.bedRooms?.length > 0
                    ? item.bedRooms
                          .map((bed) => (bed === "Studio" ? 0 : Number(bed)))
                          .filter((bed) => !Number.isNaN(bed))
                          .sort((a, b) => a - b)
                    : null,
            bathRooms: item?.baths?.length > 0 ? item?.baths : null,
            minArea: item?.minArea ? parseInt(item?.minArea) : null,
            maxArea: item?.maxArea ? (item?.maxArea !== "Any" ? parseInt(item?.maxArea) : "") : null,
            minPrice: item?.minPrice ? parseInt(item?.minPrice) : null,
            maxPrice: item?.maxPrice ? (item?.maxPrice !== "Any" ? parseInt(item?.maxPrice) : "") : null,
            purposeType: item?.purpose ? item?.purpose.toLowerCase() : "Sale",
            completionType: item?.purpose === "sale" || item?.purpose === "Sale" ? (item?.completion !== "all" ? item?.completion.toLowerCase() : null) : null,
            rentFrequency: item?.purpose === "rent" || item?.purpose === "Rent" ? (item?.rent_frequency ? item?.rent_frequency : null) : null,
            paymentPlan: item?.paymentPlan !== 0 && item?.paymentPlan !== 100 ? item?.paymentPlan : null,
            completionPercentage: item?.completionPercentage,
            completionDate: item?.completionDate ? item?.completionDate : "",
            completionDateFrom: item?.completionDate ? fromData : "",
            completionDateTo: item?.completionDate ? endDate : "",
            country: "",
            state: "",
            city: item?.city ? item?.city : "",
            locality: item?.locality ? item?.locality : "",
            developers: item?.developers ? item?.developers : null,
            searchValue: item?.searchValue ? item?.searchValue : null,
        };
        let cleanedData = Object.fromEntries(
            Object.entries(data).filter(([key, value]) => value !== NaN && value !== null && value !== undefined && value !== "" && value !== 0 && !(Array.isArray(value) && value.length === 0))
        );
        try {
            setIsLoader(true);
            let res = await PostApi(API_Path.ProjectsDetails + `/pagination?pageNumber=${page}&pageSize=${pageSize}`, { data: cleanedData });
            if (res && res.data.success) {
                let data = fatchcompletionTypeFind(completionType, res.data.data);
                setProjectData(data);
                setCurrentPage(res.data.currentPage);
                setPageSize(res.data.pageSize);
                setTotalPages(res.data.totalPages);
            }
            setBtnLoader({ serach: false, reset: false });
            setIsLoader(false);
        } catch (error) {
            setBtnLoader({ serach: false, reset: false });
            setIsLoader(false);
        }
    };
    const handlesearch = () => {
        setBtnLoader({ serach: true, reset: false });
        navigate(buildSearchUrl());
        fechLtsProjects(1, filterData);
    };
    const handleClose = () => {
        setImgModalShow(false);
        setProjectImgsmdl([]);
    };
    const tableCallBack = (page) => {
        fechLtsProjects(page, filterData);
    };
    const formatNames = (data) => {
        const names = data.map((cat) => cat.name);
        if (names.length === 1) return names[0];
        if (names.length === 2) return `${names[0]} & ${names[1]}`;
        return `${names.slice(0, -1).join(", ")} & ${names[names.length - 1]}`;
    };
    const handleReset = () => {
        navigate("/new-project");
        let data = {
            categoryName: [],
            baths: [],
            bedRooms: [],
            categories: [],
            developers: [],
            completion: "all",
            city: "",
            locality: "",
            minPrice: "",
            maxPrice: "",
            minArea: "",
            maxArea: "",
            searchValue: "",
            purpose: "Sale",
            paymentPlan: "",
            rent_frequency: "",
            completionPercentage: "",
            completionDate: "",
            country: "",
            state: "",
        };
        setBtnLoader({ serach: false, reset: true });
        setFilterData(data);
        fechLtsProjects(1, data);
    };
    const loaders = Array.from({ length: 8 });
    useEffect(() => {
        const updatedCityData = cityData.map((city) => ({ name: city.cityName, Keyname: "city" }));
        const updatedLocalityData = localityData.map((locality) => ({ name: locality.name, Keyname: "locality" }));
        const combined = [...updatedCityData, ...updatedLocalityData];
        setCombinedData(combined);
    }, [localityData, cityData]);

    const buildSearchUrl = () => {
        let url = `/new-project`;
        let firstParamAdded = true;
        const add = (key, value) => {
            if (!value || (Array.isArray(value) && value.length === 0)) return;
            url += `${firstParamAdded ? "/" : "&"}${key}=${encodeURIComponent(Array.isArray(value) ? value.join(",") : value)}`;
            firstParamAdded = false;
        };
        if (filterData?.categories?.length > 0) add("categories", filterData?.categories?.length > 0 ? filterData?.categories.join("%2") : "");
        add("completion", filterData.purpose === "sale" || filterData.purpose === "Sale" ? (filterData.completion !== "all" ? filterData.completion : "") : "");
        add("rent_frequency", filterData.purpose === "rent" || filterData.purpose === "rent" ? filterData.rent_frequency : "");
        add("price_min", filterData.minPrice);
        add("price_max", filterData.maxPrice !== "Any" ? filterData.maxPrice : "");
        add("area_min", filterData.minArea);
        add("area_max", filterData.maxArea !== "Any" ? filterData.maxArea : "");
        add("bed", filterData.bedRooms && filterData.bedRooms.length > 0 ? filterData.bedRooms : "");
        add("bath", filterData.baths && filterData.baths.length > 0 ? filterData.baths : "");
        add("city", filterData.city);
        add("locality", filterData.locality);
        add("handover_date", filterData.completionDate);
        add("pre_handover_payment_max", filterData.paymentPlan == 100 ? "" : filterData.paymentPlan);
        add("completion_percentage_max", filterData.completionPercentage == 100 ? "" : filterData.completionPercentage);
        add("dev", filterData?.developers?.length > 0 ? filterData.developers : "");
        return url;
    };

    const handlePrevClick = () => {
        setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : 0));
        setImgModalShow(false);
    };
    const handleNextClick = (item) => {
        setCurrentIndex((prevIndex) => (prevIndex < item?.length - 1 ? prevIndex + 1 : prevIndex));
        setImgModalShow(false);
    };
    const filterReset = () => {
        navigate(buildSearchUrl());
        fechLtsProjects(1, filterData);
    };
    return (
        <>
            <div className="property-dropdown">
                <div className="container">
                    <div className="hero-dropdown-sec flex-wrap project-dropdown">
                        {purposeType.length > 0 && <DropdownComponent name="Buy" kName="purpose" option={purposeType} bannerFilter={filterData} filterCallBack={filterCallBack} />}
                        <AutoMultiSearch
                            data={combinedData}
                            filterData={filterData}
                            filterCallBack={filterCallBack}
                            kName="name"
                            plshdr="Enter location"
                            multiShow={false}
                            handleReset={handleReset}
                            isIcon={true}
                            // filterReset={filterReset}
                        />
                        {filterData?.purpose?.toLowerCase() === "sale" ? (
                            <div className="buy-tab-btn property-buy-tab">
                                <div className="tab-buttons">
                                    <button className={`tab-btn${filterData.completion === "all" ? " active" : ""}`} onClick={() => filterCallBack("all", "completion")}>
                                        All
                                    </button>
                                    {completionType &&
                                        completionType.length > 0 &&
                                        completionType.map((item, i) => (
                                            <button key={i} className={`tab-btn${filterData.completion === item?.type ? " active" : ""}`} onClick={() => filterCallBack(item.type, "completion")}>
                                                {item?.name}
                                            </button>
                                        ))}
                                </div>
                            </div>
                        ) : (
                            <DropdownComponent name="yearly" kName="rent_frequency" option={rentFqcyARY} bannerFilter={filterData} filterCallBack={filterCallBack} />
                        )}
                        {categoriesType.length > 0 && (
                            <div className="dropdown">
                                <DropdownPropertys categoriesType={categoriesType} bannerFilter={filterData} filterCallBack={filterCallBack} 
                                // handlesearch={filterReset} 
                                />
                            </div>
                        )}
                        <DropdownMulti name="Beds & Baths" bannerFilter={filterData} filterCallBack={filterCallBack} 
                        // filterReset={filterReset} 
                        />
                        <MoreFilters plchdlr="Price (AED)" filterData={filterData} filterCallBack={filterCallBack} minKey="minPrice" maxKey="maxPrice"
                        //  filterReset={filterReset} 
                         />
                    </div>
                    <div className="project-plan-dropdown">
                        <div className="project-dropdown-inner">
                            <AautocompleteSearch
                                data={devNames.map((item) => {
                                    return { name: item };
                                })}
                                filterData={filterData}
                                filterCallBack={filterCallBack}
                                kName="name"
                                plshdr="developers"
                                multiShow={true}
                                handleReset={handleReset}
                                // filterReset={filterReset}
                            />
                            <DropdownQuarter name="Handover By" kName="completionDate" option={quarterARY} filterData={filterData} filterCallBack={filterCallBack} />
                            <DropdownPayment name="Payment Plan" bannerFilter={filterData} filterCallBack={filterCallBack} hKey="paymentPlan"
                            //  filterReset={filterReset}
                              />
                            <DropdownPayment name="% Completion" bannerFilter={filterData} filterCallBack={filterCallBack} hKey="completionPercentage" 
                            // filterReset={filterReset} 
                            />
                        </div>
                        <div className="dropdown-footer">
                            {(filterData.baths.length > 0 ||
                                filterData.bedRooms.length > 0 ||
                                filterData.categories.length > 0 ||
                                filterData.developers.length > 0 ||
                                filterData.city != "" ||
                                filterData.completion != "all" ||
                                filterData.locality != "" ||
                                filterData.minPrice != "" ||
                                filterData.maxPrice != "" ||
                                filterData.minArea != "" ||
                                filterData.maxArea != "" ||
                                filterData.minPrice != 0 ||
                                filterData.maxPrice != 0 ||
                                filterData.minArea != 0 ||
                                filterData.maxArea != 0 ||
                                filterData.paymentPlan != "" ||
                                filterData.completionPercentage != "" ||
                                filterData.completionDate != "" ||
                                // filterData.categorySlug == "Residential" ||
                                filterData.rent_frequency != "") && (
                                <button className="button reset_btn me-2" onClick={handleReset} disabled={btnLoader.reset}>
                                    Reset
                                </button>
                            )}
                            <button className="button search_btn" onClick={handlesearch} disabled={btnLoader.serach}>
                                Search
                                {btnLoader.serach && <span className="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section-block">
                <div className="container">
                    {isLoader ? (
                        <div className="our-latest-sec">
                            <div className="row slider-section info-block ">
                                {loaders.map((_, index) => (
                                    <div className="info-block-inner" key={index}>
                                        <ProjectLoader />
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="our-latest-sec">
                                <div className="row slider-section info-block ">
                                    {projectData.length > 0 ? (
                                        projectData.map((item, i) => (
                                            <div className="info-block-inner " key={i}>
                                                <Link to={`/project-details/${item?.slug}_${item?.uId}`} title={item.title}>
                                                    <div className="slider-card project-slider-card">
                                                        <div className="slide-card-img image-swiper-wrapper">
                                                            {item?.images.length > 0 ? (
                                                                <Swiper
                                                                    modules={[Navigation, Pagination]}
                                                                    slidesPerView={1}
                                                                    spaceBetween={20}
                                                                    navigation={{ nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }}
                                                                    pagination={{ clickable: true, dynamicBullets: true }}
                                                                    loop={false}
                                                                    className="slider_inner"
                                                                >
                                                                    {item?.images.length > 0 &&
                                                                        item?.images
                                                                            .filter((img) => !img.needHide)
                                                                            .sort((a, b) => {
                                                                                if (a.isCover) return -1;
                                                                                if (b.isCover) return 1;
                                                                                return a.orderRank - b.orderRank;
                                                                            })
                                                                            .map((slide, index) => (
                                                                                <SwiperSlide className="crad_wrapper_img" key={index}>
                                                                                    <img
                                                                                        src={imgBaseUrl + slide?.path}
                                                                                        alt={item.title}
                                                                                        onError={({ currentTarget }) => {
                                                                                            currentTarget.onerror = null;
                                                                                            currentTarget.src = `${NoPropertyImg}`;
                                                                                            setImgFlag(true);
                                                                                        }}
                                                                                        loading="lazy"
                                                                                    />
                                                                                </SwiperSlide>
                                                                            ))}
                                                                    <div className="share-info z_index-1 project-share-info">
                                                                        <div
                                                                            className="share-info-img border-0"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                setImgID(currentIndex);
                                                                                if (item?.images.length > 0) {
                                                                                    setProjectImgsmdl(item?.images);
                                                                                    setImgModalShow(true);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <RECamera />
                                                                        </div>
                                                                    </div>
                                                                    <div className="swiper-button-prev" onClick={() => handlePrevClick()}></div>
                                                                    <div className="swiper-button-next" onClick={() => handleNextClick(item?.images)}></div>
                                                                    {(item?.completionType &&  item?.completionName)&& (
                                                                        <div className="tag_label">
                                                                            <p className="z_index-1">{item?.completionName}</p>
                                                                        </div>
                                                                    )}
                                                                    {item?.category?.length > 0 && (
                                                                        <div className="key_info_value">
                                                                            <p className="card_ellipsis">{formatNames(item.category)}</p>
                                                                            {/* <p className="card_ellipsis">{item.category.map((cat) => cat.name).join(", ")}</p> */}
                                                                        </div>
                                                                    )}
                                                                </Swiper>
                                                            ) : (
                                                                <img src={NoPropertyImg} alt="No results matching your search" />
                                                            )}
                                                        </div>
                                                        <div className="heading_title">
                                                            <h1 className="card_ellipsis">{item?.title}</h1>
                                                            {item?.developer?.name && (
                                                                <p>
                                                                    By <b>{item?.developer?.name}</b>
                                                                </p>
                                                            )}
                                                        </div>
                                                        {item?.address?.locality && (
                                                             <div className="geo-location">
                                                                <RELocation />
                                                                {/* <span className="card_ellipsis">{item?.address?.locality ?? ""}</span> */}
                                                                  <span>{[item?.address?.locality, item?.address?.city, item?.address?.state].filter(Boolean).join(", ")}</span>
                                                                {/* <span>{`${item?.address?.locality ?? ""} ${item.address?.city ?? ""} ${item.address?.state ?? ""}`}</span> */}
                                                            </div>
                                                        )}
                                                        <div>
                                                            <div className="flex items-center info_wrapper">
                                                                {item?.monetary?.currency && (item?.monetary?.minimumPrice || item?.monetary?.maximumPrice) && (
                                                                    <div className="item-summary">
                                                                        <bdi className="flex items-center text-uppercase card_ellipsis">
                                                                            {`${item?.monetary?.currency} ${
                                                                                item?.monetary?.minimumPrice
                                                                                    ? formatShortNumber(item?.monetary?.minimumPrice)
                                                                                    : formatShortNumber(item?.monetary?.maximumPrice)
                                                                            }`}
                                                                        </bdi>
                                                                        <span className="card_ellipsis">Launch price</span>
                                                                    </div>
                                                                )}
                                                                {item?.completion?.completionDate && (
                                                                    <div className="item-summary">
                                                                        <bdi className="flex items-center card_ellipsis">{getQuarter(item?.completion?.completionDate)}</bdi>
                                                                        <span className="card_ellipsis">handover</span>
                                                                    </div>
                                                                )}
                                                                {(item?.paymentPlans?.postHandoverPercentageSum || item?.paymentPlans?.preHandoverPercentageSum) && (
                                                                    <div className="item_summary_inner">
                                                                        <div className="wrapper" ref={wrapperRef} onMouseEnter={updatePosition}>
                                                                            <div className="item-summary">
                                                                                <h2>
                                                                                    <bdi className="flex items-center card_ellipsis">
                                                                                        {item?.paymentPlans?.preHandoverPercentageSum}/{item?.paymentPlans?.postHandoverPercentageSum}
                                                                                    </bdi>
                                                                                    <svg
                                                                                        stroke="currentColor"
                                                                                        fill="currentColor"
                                                                                        strokeWidth="0"
                                                                                        viewBox="0 0 512 512"
                                                                                        height="1em"
                                                                                        width="1em"
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                    >
                                                                                        <path
                                                                                            fill="none"
                                                                                            strokeMiterlimit="10"
                                                                                            strokeWidth="32"
                                                                                            d="M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z"
                                                                                        ></path>
                                                                                        <path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M220 220h32v116"></path>
                                                                                        <path fill="none" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="32" d="M208 340h88"></path>
                                                                                        <path d="M248 130a26 26 0 1 0 26 26 26 26 0 0 0-26-26z"></path>
                                                                                    </svg>
                                                                                    <div ref={tooltipRef} className={`tooltip ${position}`}>
                                                                                        <div className="payment-plan-head">
                                                                                            <h3>% OF PROPERTY VALUE TO BE PAID</h3>
                                                                                            {item?.paymentPlans?.downPaymentPercentage && (
                                                                                                <div className="payment-plan-show">
                                                                                                    <span>Down Payment</span>
                                                                                                    <strong>{item?.paymentPlans?.downPaymentPercentage}%</strong>
                                                                                                </div>
                                                                                            )}
                                                                                            {item?.paymentPlans?.preHandoverPercentage && (
                                                                                                <div className="payment-plan-show">
                                                                                                    <span>During Construction</span>
                                                                                                    <strong>{item?.paymentPlans?.preHandoverPercentage}%</strong>
                                                                                                </div>
                                                                                            )}
                                                                                            {item?.paymentPlans?.handoverPercentage && (
                                                                                                <div className="payment-plan-show">
                                                                                                    <span>On Handover</span>
                                                                                                    <strong>{item?.paymentPlans?.handoverPercentage}%</strong>
                                                                                                </div>
                                                                                            )}
                                                                                            {item?.paymentPlans?.postHandoverPercentage && (
                                                                                                <div className="payment-plan-show">
                                                                                                    <span>Post Handover</span>
                                                                                                    <strong>{item?.paymentPlans?.postHandoverPercentage}%</strong>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </h2>
                                                                                <span className="card_ellipsis">Payment Plan </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="wp_btn">
                                                            <button
                                                                className="button"
                                                                data-framer-name="WhatsApp"
                                                                // href="https://api.whatsapp.com/send/?app_absent=0&amp;phone=971585677441&amp;text&amp;type=phone_number"
                                                                // target="_blank"
                                                                // rel="noopener"
                                                                // style="will-change: transform;opacity: 1;transform: perspective(1200px);"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    sendWhatsAppMessage(wpNumber, "HI");
                                                                }}
                                                            >
                                                                <REWhatsapp className="me-1" />
                                                                {/* <IoLogoWhatsapp fill="#4dbd43" className="me-1" /> */}
                                                                 WhatsApp
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="content_notfound">
                                            <img src={noDataFound} alt="No results matching your search" />
                                            <h3>No results matching your search.</h3>
                                            <p>You could try to remove some filters.</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {projectData.length > 0 && <CommonPagination currentPage={currentPage} pageSize={pageSize} totalPages={totalPages} tableCallBack={tableCallBack} />}
                        </>
                    )}
                </div>
            </div>
            {/* modal */}
            {!imgFlag && <ImagesModal show={imgModalShow} handleHide={handleClose} propertyImgsmdl={projectImgsmdl} id={imgID} />}
        </>
    );
}
